import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'gem-slider',
  standalone: false,
  styleUrls: ['gem-slider.component.scss'],
  template: `
    <div class="d-flex align-items-center">
      <div>
        <mat-label>{{ label | translate }}: </mat-label>
        <mat-slider class="example-margin" [max]="max" [min]="min" [step]="step" [showTickMarks]="showTicks">
          <input matSliderThumb [formControl]="control" #slider />
        </mat-slider>
      </div>
      <div class="ms-3">{{ getDisplayValue() }}</div>
    </div>
  `,
})
export class GemSliderComponent {
  @Input() control: FormControl = new FormControl();
  @Input() label: string = '';
  @Input() min: number = 0.0;
  @Input() max: number = 1.0;
  @Input() step: number = 0.0;
  @Input() showTicks: boolean = false;
  @Input() displayValueFn?: (value: number) => string;

  constructor() {}

  getDisplayValue(): string {
    const value = this.control.value;
    return this.displayValueFn ? this.displayValueFn(value) : `${value}`;
  }
}
